import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { useMe } from './lib/auth';
import { applyTheme } from './lib/theme';
import { hasPermission } from '@voice/shared';
import { Dashboard } from './pages/Dashboard';
import { Extensions } from './pages/Extensions';
import { Users } from './pages/Users';
import { Login } from './pages/Login';
import { CallLog } from './pages/CallLog';
import { Inbox } from './pages/Inbox';
import { MyPhone } from './pages/MyPhone';
import { FlowEditor, FlowList } from './pages/Flows';
import { Settings } from './pages/Settings';
import { Integrations } from './pages/Integrations';
import { Team } from './pages/Team';
import { Audio } from './pages/Audio';
import { Contacts } from './pages/Contacts';
import { ParkingConference } from './pages/ParkingConference';
import { Queues } from './pages/Queues';
import { Schedules } from './pages/Schedules';
import { Trunks } from './pages/Trunks';
import { Wallboard } from './pages/Wallboard';

export function App() {
  const me = useMe();
  const theme = me.data?.theme;

  useEffect(() => {
    if (theme) applyTheme(theme);
  }, [theme]);

  if (me.isPending) return null;
  if (me.isError) return <p style={{ padding: 32 }}>Der Server ist nicht erreichbar. Bitte später erneut versuchen.</p>;

  if (!me.data) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<Layout user={me.data} />}>
        <Route index element={<Dashboard user={me.data} />} />
        {hasPermission(me.data.permissions, 'extensions.manage') && <Route path="nebenstellen" element={<Extensions canManageUsers={hasPermission(me.data.permissions, 'users.manage')} />} />}
        {hasPermission(me.data.permissions, 'users.manage') && <Route path="benutzer" element={<Users currentUserId={me.data.id} />} />}
        <Route path="mein-telefon" element={<MyPhone />} />
        <Route path="anrufe" element={<CallLog user={me.data} />} />
        <Route path="nachrichten" element={<Inbox user={me.data} />} />
        {hasPermission(me.data.permissions, 'callflows.manage') && <Route path="ablaeufe" element={<FlowList />} />}
        {hasPermission(me.data.permissions, 'callflows.manage') && <Route path="ablaeufe/:id" element={<FlowEditor />} />}
        <Route path="einstellungen" element={<Settings user={me.data} />} />
        <Route path="team" element={<Team />} />
        {hasPermission(me.data.permissions, 'integrations.manage') && <Route path="schnittstellen" element={<Integrations />} />}
        <Route path="kontakte" element={<Contacts />} />
        {hasPermission(me.data.permissions, 'queues.supervise') && <Route path="live" element={<Wallboard />} />}
        {hasPermission(me.data.permissions, 'queues.manage') && <Route path="warteschlangen" element={<Queues />} />}
        {hasPermission(me.data.permissions, 'trunks.manage') && <Route path="leitungen" element={<Trunks />} />}
        {hasPermission(me.data.permissions, 'media.manage') && <Route path="ansagen" element={<Audio />} />}
        {hasPermission(me.data.permissions, 'schedules.manage') && <Route path="zeiten" element={<Schedules />} />}
        {hasPermission(me.data.permissions, 'callflows.manage') && <Route path="parken" element={<ParkingConference />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
